import '../styles/rules.css';
import { useTranslation } from '../hooks/useTranslation';
import SEO from '../components/SEO';

const Privacy = () => {
  const { t } = useTranslation();

  const createMarkup = (htmlString) => {
    return { __html: htmlString };
  };

  return (
    <div>
      <SEO
        title="Политика конфиденциальности — Diamond VPN"
        description="Политика конфиденциальности Diamond VPN: мы не храним логи трафика и не отслеживаем вашу активность. Узнайте, какие технические данные используются для работы сервиса."
        ogImage="https://diamondvpn.online/preview.jpg"
      />
      <div className="rules-content">
        <div className="rules-container">
          <h1>{t('privacy.title')}</h1>
          
          <p>{t('privacy.effectiveDate')}</p>

          <h2>{t('privacy.sections.noLogs')}</h2>
          <p dangerouslySetInnerHTML={createMarkup(t('privacy.content.noLogs.description'))} />
          <ul className="ul-items">
            {t('privacy.content.noLogs.items').map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          <p>{t('privacy.content.noLogs.conclusion')}</p>

          <h2>{t('privacy.sections.technicalInfo')}</h2>
          <p>{t('privacy.content.technicalInfo.description')}</p>
          <ul className="ul-items">
            {t('privacy.content.technicalInfo.items').map((item, index) => (
              <li key={index} dangerouslySetInnerHTML={createMarkup(item)} />
            ))}
          </ul>

          <h2>{t('privacy.sections.paymentInfo')}</h2>
          <p>{t('privacy.content.paymentInfo.description')}</p>
          <p dangerouslySetInnerHTML={createMarkup(t('privacy.content.paymentInfo.conclusion'))} />

          <h2>{t('privacy.sections.dataProtection')}</h2>
          <p>{t('privacy.content.dataProtection')}</p>

          <h2>{t('privacy.sections.thirdParty')}</h2>
          <p>{t('privacy.content.thirdParty')}</p>
          
        </div>
      </div>
    </div>
  );
};

export default Privacy;
